import React from 'react';
import { motion } from 'framer-motion';
import { PageShell } from '../components/PageShell';
import { SectionHeading } from '../components/SectionHeading';
import { capitalMetrics, metrics } from '../data/profile';
export function ImpactMetrics() {
  return <PageShell path="/impact" data-id="element-358" data-mp="2ayi7v5zwk3pv">
      <section id="headline-outcomes" className="bg-navy-950 py-20 lg:py-24" aria-labelledby="headline-metrics-heading" data-id="element-359" data-mp="2g07n6xu5r3jr">
        <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-360" data-mp="1idqq9tpc6ryj">
          <div id="headline-metrics-heading" data-id="element-361" data-mp="1nc21a7rdb8ic">
            <SectionHeading eyebrow="Headline Outcomes" title="Four numbers that define the record" tone="dark" data-id="element-362" data-mp="1n8xm6fcd6scw" />
          </div>

          <dl className="mt-12 grid grid-cols-1 gap-y-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-y-0" data-id="element-363" data-mp="1x24ti5qo0ifm">
            {metrics.map((metric, index) => <motion.div key={metric.value + metric.label} initial={{
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.4
          }} transition={{
            duration: 0.28,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className={`flex flex-col lg:px-8 ${index === 0 ? 'lg:pl-0' : 'lg:border-l lg:border-white/10'}`} data-id="element-364" data-mp="14jzf6gvyj00p" data-mpi={index}>
                <dd className="font-display text-4xl font-extrabold tracking-tightest text-gold-400 xl:text-5xl" data-id="element-365" data-mp="3hnp5k03lsh8d">
                  {metric.value}
                </dd>
                <dt className="mt-4 font-display text-base font-semibold leading-snug text-white" data-id="element-366" data-mp="3cqyopajz5hlw">
                  {metric.label}
                </dt>
                <dd className="mt-3 font-sans text-sm leading-relaxed text-platinum-300" data-id="element-367" data-mp="33p8xa4q3eio4">
                  {metric.detail}
                </dd>
              </motion.div>)}
          </dl>
        </div>
      </section>

      <section id="capital-metrics" className="bg-white py-20 lg:py-24" aria-labelledby="capital-metrics-heading" data-id="element-368" data-mp="11xceca1li6jb">
        <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-369" data-mp="30603hzgf917p">
          <div id="capital-metrics-heading" data-id="element-370" data-mp="308cu1108wjwd">
            <SectionHeading eyebrow="Capital Metrics" title="Scale, spend and reach behind the headlines" description="Supporting measures of capital deployed, estate governed and people reached." data-id="element-371" data-mp="2mfo6pn8w6ea8" />
          </div>

          <dl className="mt-12 grid grid-cols-1 gap-px border border-platinum-200 bg-platinum-200 sm:grid-cols-2 lg:grid-cols-3" data-id="element-372" data-mp="3j55lcrpurao2">
            {capitalMetrics.map(metric => <div key={metric.label} className="flex flex-col bg-white p-8" data-id="element-373" data-mp="357h0vkzp65jj">
                <dd className="font-display text-3xl font-extrabold tracking-tightest text-navy-900" data-id="element-374" data-mp="3a2wbm42erlbq">
                  {metric.value}
                </dd>
                <dt className="mt-3 font-display text-sm font-bold uppercase tracking-[0.1em] text-gold-600" data-id="element-375" data-mp="1yp0u4oo170hc">
                  {metric.label}
                </dt>
                <dd className="mt-auto pt-4 font-sans text-sm leading-relaxed text-charcoal-600" data-id="element-376" data-mp="1qad22zsu5vpm">
                  {metric.detail}
                </dd>
              </div>)}
          </dl>
        </div>
      </section>
    </PageShell>;
}